import { responsive, responsiveContainer } from "@huub-web/ui/utils/responsive";
import { activeState } from "@huub-web/ui/theme/activeState";
import { disabledState } from "@huub-web/ui/theme/disabledState";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";
import { type RuntimeFn, recipe } from "@vanilla-extract/recipes";

import { theme } from "@huub-web/ui/theme/css/theme.css";
import { ANALYSIS_INDEX_BREAKPOINT } from "../AnalysisIndex.css";

/**
 * Explicit `RuntimeFn` annotation avoids TS2742 under pnpm, where the
 * inferred type references csstype through the virtual store path.
 * @see https://github.com/vanilla-extract-css/vanilla-extract/pull/890
 */
export const containerStyle: RuntimeFn<{
  positiveCount: { true: Record<string, unknown> };
  disabled: { true: Record<string, unknown> };
  noData: { true: Record<string, unknown> };
  loading: { true: Record<string, unknown> };
}> = recipe({
  base: {
    listStyle: "none",
    position: "relative",
    selectors: {
      "&:not([aria-disabled]):after": {
        content: '""',
        position: "absolute",
        bottom: rem(-20),
        left: 0,
        width: "100%",
        height: rem(1),
        background: theme.colors.defaultBorder,
        zIndex: 0,
        pointerEvents: "none",
      },
      "&:not([aria-disabled]):last-child:after": {
        display: "none",
      },
    },
  },
  variants: {
    positiveCount: {
      true: {
        selectors: {
          "&:not([aria-disabled]):nth-last-child(2):after": {
            ...(responsiveContainer({
              [ANALYSIS_INDEX_BREAKPOINT]: {
                display: "none",
              },
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }) as any),
          },
        },
      },
    },
    disabled: {
      true: {
        ...disabledState,
        opacity: 0.25,
      },
    },
    noData: {
      true: {},
    },
    loading: {
      true: {},
    },
  },
});

export const buttonStyle = recipe({
  base: {
    width: "100%",
    borderRadius: theme.borderRadiuses.xs,
    gap: theme.spacings.xxs,
    ...responsive({
      [ANALYSIS_INDEX_BREAKPOINT]: {
        gap: theme.spacings.m,
      },
    }),
    selectors: {
      "&:not([disabled])": {
        cursor: "pointer",
      },
      "&:active:not([disabled])": {
        ...activeState,
      },
    },
  },
});

export const indexTextStyle = style({
  width: rem(42),
});

export const titleStyle = style({});

export const iconButtonStyle = style({
  pointerEvents: "none",
});
